

export class UpdateMainMenuOutput implements IUpdateMainMenuOutput {
    status!: number;
    message!: string;

    constructor(data?: IUpdateMainMenuOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateMainMenuOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMainMenuOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IUpdateMainMenuOutput {
    status: number;
    message: string;
}

